export default "__VITE_ASSET__CDHc8_lw__"